import Preact, { Component } from 'preact';
import { ManagePreferenceModal } from './ManagePreferenceModal/ManagePreferenceModal';
import { CookieBannerPopup } from './CookieBannerPopup/CookieBannerPopup';
import cookie from 'cookie';
import makeAPIRequest from '@jg/http-client';
import { clientConfig } from '../../config';
import { Experiments, Variants } from '../../constants/experiments';

interface Props {}
declare global {
  interface Window {
    CookieConsent: any;
  }
}

interface State {
  isBannerOpen: boolean;
  isManagePrefOpen: boolean;
  hasResponse: boolean;
  enrolledVariant: string;
}

export class CookieBanner extends Component<Props> {
  state: State = {
    isManagePrefOpen: false,
    isBannerOpen: true,
    hasResponse: false,
    enrolledVariant: '',
  };

  componentDidMount() {
    // Task: 1982872 - Enrol user to AB test for cookiebot banner. REMOVE IT ONCE RESULT COMPLETE.
    this.enrolUserToAbTest();
    window.addEventListener('loadCookieBot', this.showModal);
    window.addEventListener('cookiebotMoreOptions', this.showManagePreference);
    window.addEventListener('cookiebotAcceptBlueBanner', () =>
      this.markSuccessForAbTest('CookiebotBlueBannerAcceptedAll'),
    );
    let hasCookieResponse = cookie.parse(document.cookie)['CookieConsent']
      ? true
      : false;
    this.setState({
      isManagePrefOpen: false,
      isBannerOpen: true,
      hasResponse: hasCookieResponse,
    });
  }
  showModal = () => {
    this.setState({
      isManagePrefOpen: false,
      isBannerOpen: true,
      hasResponse: false,
    });
  };

  showManagePreference = () => {
    this.setState({
      isManagePrefOpen: true,
      isBannerOpen: false,
      hasResponse: false,
    });
  };

  setBannerAndManagePrefPopup = (
    isManagePrefValue: any,
    isBannerOpenValue: any,
  ) => {
    this.setState({
      isManagePrefOpen: isManagePrefValue,
      isBannerOpen: isBannerOpenValue,
    });
  };
  setHasResponse = (hasResponseValue: any) => {
    this.setState({
      isManagePrefOpen: this.state.isManagePrefOpen,
      isBannerOpen: this.state.isBannerOpen,
      hasResponse: hasResponseValue,
    });
  };
  render() {
    return (
      <div>
        {this.state.enrolledVariant == Variants.A &&
          !this.state.hasResponse &&
          this.state.isBannerOpen && (
            <CookieBannerPopup
              openManagePref={false}
              handleManagePref={this.setBannerAndManagePrefPopup}
              setHasResponse={this.setHasResponse}
              markSuccess={() =>
                this.markSuccessForAbTest('CookiebotPopupAcceptedAll')
              }
            />
          )}
        {this.state.isManagePrefOpen && (
          <ManagePreferenceModal
            openManagePref={this.state.isManagePrefOpen}
            handleManagePref={this.setBannerAndManagePrefPopup}
            setHasResponse={this.setHasResponse}
            markSuccess={(p: boolean, s: boolean, m: boolean) => {
              this.saveChangesMarkSuccess(p, s, m);
            }}
          />
        )}
      </div>
    );
  }

  private saveChangesMarkSuccess(p: boolean, s: boolean, m: boolean) {
    let abSuccess = '';
    if (p) {
      abSuccess = abSuccess.concat('-P');
    }
    if (s) {
      abSuccess = abSuccess.concat('-S');
    }
    if (m) {
      abSuccess = abSuccess.concat('-M');
    }
    this.markSuccessForAbTest(`CookiebotPopupSaveChanges-N${abSuccess}`);
  }

  async enrolUserToAbTest() {
    const { jgAnalyticsCookieName, abApiUrl } = clientConfig;
    const guids = cookie.parse(document.cookie)[jgAnalyticsCookieName];
    if (guids) {
      const response = await makeAPIRequest(
        `${abApiUrl}/api/abtests/${Experiments.cookie_banner_optin_rate}/enrol`,
        {
          method: 'POST',
          credentials: 'include',
          headers: {
            cookie: `${jgAnalyticsCookieName}=${guids}`,
          },
        },
      );
      if (response.ok) {
        const result = await response.json();
        const enrolled = result && result.enrolledIn;
        this.setState({ enrolledVariant: enrolled });
        var cookiebotBlueBanner = window.document.getElementById(
          'CybotCookiebotDialogv2',
        );
        if (!this.state.hasResponse && cookiebotBlueBanner)
          cookiebotBlueBanner.style.display =
            enrolled == Variants.B ? 'block' : 'none';
      }
    } else {
      this.setState({ enrolledVariant: Variants.A });
    }
  }

  async markSuccessForAbTest(typeName: string) {
    const { jgAnalyticsCookieName, abApiUrl } = clientConfig;
    const guids = cookie.parse(document.cookie)[jgAnalyticsCookieName];
    if (guids) {
      await makeAPIRequest(
        `${abApiUrl}/api/abtests/${
          Experiments.cookie_banner_optin_rate
        }/markSuccessful`,
        {
          method: 'POST',
          credentials: 'include',
          headers: {
            cookie: `${jgAnalyticsCookieName}=${guids}`,
            Accept: 'application/json, text/plain, */*',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            successType: typeName,
          }),
        },
      );
    }
  }
}
export default CookieBanner;
